'use client';

import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import type { Swiper as SwiperType } from 'swiper';
import { ReferralData, mediaUrl } from './referralData';

const testimonials = [
  {
    quote:
      'I referred just a few friends and was surprised by how quickly I started earning rewards. The process is smooth and super transparent.',
    name: 'Riya Sharma',
    image:
      'https://static.amityonline.com/_s/Group_480993222_bb3c5f0b5a_0e75350024_04c9f919e4.webp',
  },
  {
    quote:
      'Being part of the ambassador program helped me build my network and gain recognition. The badges and rewards are a great motivation.',
    name: 'Arjun Mehta',
    image:
      'https://static.amityonline.com/_s/Group_4809932223_9dc8a46ff8_ac04adae91.webp',
  },
];

function QuoteMark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className='w-14 h-14 sm:h-7 sm:w-7 absolute -left-4 sm:-left-5 sm:-bottom-2 bottom-4'  viewBox="0 0 70 70" fill="none">
<g clipPath="url(#clip0_2240_1670)">
<path d="M66.582 11.792C66.9562 12.1194 67.1055 12.3365 67.154 12.8371C67.1712 13.3805 67.1496 13.748 66.8555 14.2187C66.5683 14.4119 66.5683 14.4119 66.213 14.5878C66.0173 14.6866 66.0173 14.6866 65.8176 14.7875C65.608 14.8909 65.608 14.8909 65.3943 14.9963C65.1057 15.1431 64.8173 15.2903 64.5291 15.438C64.3884 15.51 64.2477 15.5819 64.1027 15.6561C60.5611 17.4939 57.0409 20.1095 55.7813 24.0625C55.301 25.911 55.5033 27.649 56.4563 29.3091C57.2203 30.2814 57.9909 30.7871 59.1565 31.1462C62.1123 32.1033 64.0227 34.4454 65.4152 37.1119C67.4403 41.1867 67.7314 46.1354 66.3599 50.4492C65.015 54.4018 62.1651 57.7117 58.4468 59.609C56.1897 60.715 53.9359 61.2757 51.4236 61.2828C51.1464 61.2841 50.8693 61.2884 50.5921 61.2927C46.5413 61.3256 42.9802 59.6438 40.1099 56.8579C36.1635 52.8826 34.9189 47.254 34.9326 41.834C34.9845 35.5469 36.8784 29.4765 40.7422 24.4726C40.8297 24.3588 40.8297 24.3588 40.919 24.2426C42.6911 21.9723 44.8167 19.9749 47.168 18.3203C47.251 18.2607 47.3339 18.2012 47.4194 18.1398C51.4289 15.2742 61.5456 9.69347 66.582 11.792Z" fill="#FFC107"/>
<path d="M31.582 11.792C31.9562 12.1194 32.1055 12.3365 32.154 12.8371C32.1712 13.3805 32.1496 13.748 31.8555 14.2187C31.5683 14.4119 31.5683 14.4119 31.213 14.5878C31.0173 14.6866 31.0173 14.6866 30.8176 14.7875C30.608 14.8909 30.608 14.8909 30.3943 14.9963C30.1057 15.1431 29.8173 15.2903 29.5291 15.438C29.3884 15.51 29.2477 15.5819 29.1027 15.6561C25.5611 17.4939 22.0409 20.1095 20.7813 24.0625C20.301 25.911 20.5033 27.649 21.4563 29.3091C22.2203 30.2814 22.9909 30.7871 24.1565 31.1462C27.1123 32.1033 29.0227 34.4454 30.4152 37.1119C32.4403 41.1867 32.7314 46.1354 31.3599 50.4492C30.015 54.4018 27.1651 57.7117 23.4468 59.609C21.1897 60.715 18.9359 61.2757 16.4236 61.2828C16.1464 61.2841 15.8693 61.2884 15.5921 61.2927C11.5413 61.3256 7.98021 59.6438 5.10987 56.8579C1.16354 52.8826 -0.0810787 47.254 -0.0674245 41.834C-0.0154833 35.5469 1.87841 29.4765 5.74219 24.4726C5.82973 24.3588 5.82973 24.3588 5.91903 24.2426C7.69107 21.9723 9.81671 19.9749 12.168 18.3203C12.251 18.2607 12.3339 18.2012 12.4194 18.1398C16.4289 15.2742 26.5456 9.69347 31.582 11.792Z" fill="#FFC107"/>
</g>
<defs>
<clipPath id="clip0_2240_1670">
<rect width="70" height="70" fill="white"/>
</clipPath>
</defs>
</svg>
  );
}

function ArrowButton({
  dir,
  onClick,
}: {
  dir: 'prev' | 'next';
  onClick: () => void;
}) {

  const handle = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.requestAnimationFrame(onClick);
  };
  return (
    <button
      type="button"
      onClick={handle}
      onTouchEnd={handle}
      aria-label={dir === 'prev' ? 'Previous testimonial' : 'Next testimonial'}
      className="absolute top-1/2 -translate-y-1/2 z-10 flex h-9 w-9 md:h-11 md:w-11 items-center justify-center rounded-full bg-[#EAEDF2] text-[#1A325D] hover:bg-[#dfe3ea] transition-colors"
      style={{
        [dir === 'prev' ? 'left' : 'right']: "-10px",
        touchAction: 'manipulation',
      } as React.CSSProperties}
    >
      <svg width="18"  height="18" viewBox="0 0 24 24" fill="none">
        <path
          d={dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'}
          stroke="#1A325D"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default function TestimonialSlider({ data }: { data?: ReferralData['AmbassadorsReferral'] }) {
  const swiperRef = useRef<SwiperType | null>(null);

  const heading = data?.Heading || 'Hear from Our Amity Online Ambassadors';
  const list = data?.AmbassadorsReferralList;
  const slides =
    list && list.length
      ? list.map((t) => ({
          quote: t.Text || '',
          name: t.Name || '',
          image: mediaUrl(t.Image) || '',
        }))
      : testimonials;

  return (
    <section className="bg-[#F8F9FB] py-12">
      <div className="px-4 md_2:px-10">
        <h2 className="text-[32px] sm:text-[26px] leading-[1.15] md_2:text-[34px] font-bold text-[#1A325D] mb-8 md_2:mb-12 text-left md_2:text-center">
          {heading}
        </h2>

        <div className="relative max-w-[1280px] mx-auto px-6 sm:px-5 md_2:px-16">
          <ArrowButton dir="prev" onClick={() => swiperRef.current?.slidePrev()} />
          <ArrowButton dir="next" onClick={() => swiperRef.current?.slideNext()} />

          <Swiper
            modules={[Autoplay]}
            onSwiper={(s) => (swiperRef.current = s)}
            slidesPerView={1}
            loop={slides.length > 2}
            speed={700}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            className="[&_.swiper-wrapper]:items-stretch [&_.swiper-slide]:!h-auto [&_.swiper-slide]:flex"
          >
            {slides.map((t) => (
              <SwiperSlide key={t.name}>
                <div className="w-full h-full rounded-[24px] md_2:rounded-[28px] border-2 border-[#FFC907] bg-[#16285C] p-4 sm:p-6 md:p-8  lg:px-8 lg:py-6 text-white ">
                  <div className="flex items-start md_2:items-center gap-3 sm:gap-2 md:gap-6 lg:gap-8">
                    <div className="shrink-0 relative">
                      <QuoteMark />
                    </div>

                    <div className="flex-1 lg:gap-6 lg:flex lg:flex-col lg:ml-7 min-w-0">
                      <p className="text-[13px] sm:text-[12px] md:text-lg lg:text-[22px] leading-tight">
                        {t.quote}
                      </p>
                      <p className="text-[#FFC907] font-bold mt-3 sm:mt-5 text-xl sm:text-base md:text-lg">
                        — {t.name}
                      </p>
                    </div>

                    <img
                      src={t.image}
                      alt={t.name}
                      className="shrink-0 h-[64px] w-[64px] sm:h-[60px] sm:w-[60px] md:h-[120px] md:w-[130px] lg:h-[140px] lg:w-[140px] rounded-full object-cover border-[3px] sm:border-[4px] border-white"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
